export default function RexpertLogo({ compact = false, dark = true, className = "", testId = "rexpert-logo" }) {
  const textPrimary = dark ? "text-[#2B3037]" : "text-[#2B3037]";
  const textSecondary = dark ? "text-[#d2c2a3]" : "text-[#7A6438]";
  const wordmarkSurface = dark ? "" : "";
  const emblemSize = compact ? "h-[62px] w-[62px]" : "h-[98px] w-[98px]";

  return (
    <div className={`flex items-center gap-4 ${className}`} data-testid={testId}>
      <img
        src="/reexperts-seal-gemini.png"
        alt="REEXPERTS Siegel"
        className={`${emblemSize} shrink-0 object-contain object-center`}
        data-testid={`${testId}-crest`}
      />

      {!compact && (
        <div className="flex w-[320px] flex-col items-start justify-center gap-1 text-left">
          <p className={`font-mono text-[10px] uppercase tracking-[0.22em] leading-none ${textSecondary}`} data-testid={`${testId}-eyebrow`}>
            Vereinigung freier Immobiliensachverständiger
          </p>
          <p className={`font-sans text-[2.08rem] font-extrabold leading-none tracking-[-0.05em] ${wordmarkSurface}`} style={{ textShadow: dark ? "0 0 0 transparent" : "0 1px 0 rgba(255,255,255,0.45)" }} data-testid={`${testId}-wordmark`}>
            <span className={textPrimary}>RE</span>
            <span className="text-[#A0272B]">EX</span>
            <span className={textPrimary}>PERTS</span>
          </p>
          <div className="flex items-center gap-2.5" data-testid={`${testId}-flag-accent`}>
            <span className="h-[4px] w-9 rounded-full bg-[#2f343c]" />
            <span className="h-[4px] w-9 rounded-full bg-[#a0272b]" />
            <span className="h-[4px] w-9 rounded-full bg-[#d4af37]" />
          </div>
          <p className={`font-mono text-[10px] uppercase tracking-[0.18em] leading-none ${textSecondary}`} data-testid={`${testId}-subline`}>
            reexperts.de · D-A-CH
          </p>
        </div>
      )}
    </div>
  );
}
